export const prefixPhoneNumberWithPlus = (phoneNumber: string | undefined) => {
  if (!phoneNumber) return "";
  if (phoneNumber.at(0) === "+") return phoneNumber;
  return `+${phoneNumber}`;
};
